function addDialogEventListeners() {
  const productAdditionalInfoContentButtons = document.querySelectorAll('.product-additional-info-button');
  productAdditionalInfoContentButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const dialog = button.nextElementSibling;
      if (dialog) {
        const currentScrollY = window.scrollY || document.documentElement.scrollTop || 0;
        document.body.dataset.scrollY = String(currentScrollY);
        document.body.style.top = `-${currentScrollY}px`;
        dialog.showModal();
        document.body.classList.add('dialog-open');
      }
    });
  });

  const productAdditionalInfoContentDialogCloseButtons = document.querySelectorAll('.product-additional-info-button-close');
  productAdditionalInfoContentDialogCloseButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const dialog = button.closest('.product-additional-info-content-dialog');
      if (dialog) {
        setTimeout(function() {
          dialog.close();
        }, 300);
        const previousScrollY = parseInt(document.body.dataset.scrollY || '0', 10);
        document.body.classList.remove('dialog-open');
        document.body.style.top = '';
        window.scrollTo(0, previousScrollY);
        try { delete document.body.dataset.scrollY; } catch (_) { document.body.dataset.scrollY = ''; }
      }
    });
  });

  // Close dialog when clicking outside the content area
  const productAdditionalInfoContentDialogs = document.querySelectorAll('.product-additional-info-content-dialog');
  productAdditionalInfoContentDialogs.forEach(function(dialog) {
    dialog.addEventListener('click', function(e) {
      // Check if the click is on the dialog backdrop (not on the content)
      if (e.target === dialog) {
        setTimeout(function() {
          dialog.close();
        }, 300);
        const previousScrollY = parseInt(document.body.dataset.scrollY || '0', 10);
        document.body.classList.remove('dialog-open');
        document.body.style.top = '';
        window.scrollTo(0, previousScrollY);
        try { delete document.body.dataset.scrollY; } catch (_) { document.body.dataset.scrollY = ''; }
      }
    });
  });
}

function setProductSwiper() {
  const productSwiper = document.querySelector('.product-swiper');
  if (productSwiper) {
    new Swiper(productSwiper, {
      slidesPerView: 1,
      spaceBetween: 0,
      mousewheel: true,
      keyboard: true,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }
}

function setButtonsContainerHeight() {
  const buttonsContainer = document.querySelector('.product-buttons-container');
  if (buttonsContainer) {
    document.documentElement.style.setProperty('--buttons-container-height', buttonsContainer.offsetHeight + 'px');
  }
}

function handleMobileFooterVisibility() {
  const buttonsContainer = document.querySelector('.product-buttons-container');
  const footer = document.querySelector('footer');
  
  if (!buttonsContainer || !footer) return;
  
  function checkFooterVisibility() {
    const isMobile = window.innerWidth < 768; // Adjust breakpoint as needed
    const footerRect = footer.getBoundingClientRect();
    const isFooterVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;
    
    if (isMobile && isFooterVisible) {
      buttonsContainer.style.display = 'none';
    } else {
      buttonsContainer.style.display = '';
    }
  }
  
  // Check on scroll and resize
  window.addEventListener('scroll', checkFooterVisibility);
  window.addEventListener('resize', checkFooterVisibility);
  
  // Initial check
  checkFooterVisibility();
}

function initProductMediaZoom() {
  // Select media items - use desktop as source to avoid duplicates when cloning
  const mediaItemsDesktop = document.querySelectorAll('.product-media-container-desktop .product-media-item');
  const mediaItemsMobile = document.querySelectorAll('.product-media-container-mobile .product-media-item');
  
  // Create fullscreen overlay if it doesn't exist
  let fullscreenOverlay = document.getElementById('product-media-fullscreen');
  if (!fullscreenOverlay) {
    fullscreenOverlay = document.createElement('div');
    fullscreenOverlay.id = 'product-media-fullscreen';
    fullscreenOverlay.className = 'product-media-fullscreen';
    fullscreenOverlay.innerHTML = `
      <button class="product-media-fullscreen-close" aria-label="Close fullscreen">X</button>
      <div class="product-media-fullscreen-content"></div>
    `;
    document.body.appendChild(fullscreenOverlay);
  }

  const fullscreenContent = fullscreenOverlay.querySelector('.product-media-fullscreen-content');
  const closeButton = fullscreenOverlay.querySelector('.product-media-fullscreen-close');

  // Function to add zoom functionality
  function addZoomToItems(items, sourceItems) {
    items.forEach(function(item, idx) {
      // Skip if already initialized
      if (item.dataset.zoomInitialized === 'true') {
        return;
      }
      item.dataset.zoomInitialized = 'true';
      
      item.style.cursor = 'zoom-in';
      item.addEventListener('click', function(e) {
        // Clear all previous content first
        while (fullscreenContent.firstChild) {
          fullscreenContent.removeChild(fullscreenContent.firstChild);
        }
        
        // Clone from desktop source to avoid duplicates
        sourceItems.forEach(function(media, i) {
          const mediaClone = media.cloneNode(true);
          mediaClone.classList.add('product-media-fullscreen-item');
          if (i === idx) {
            mediaClone.classList.add('active'); // la imagen clicada
          }
          fullscreenContent.appendChild(mediaClone);
        });

        // Opcional: scroll automático a la imagen clicada
        setTimeout(function() {
          const activeMedia = fullscreenContent.querySelector('.product-media-fullscreen-item.active');
          if (activeMedia) {
            activeMedia.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'});
          }
        }, 50);

        // Save current scroll position
        const currentScrollY = window.scrollY || document.documentElement.scrollTop || 0;
        document.body.dataset.scrollY = String(currentScrollY);
        document.body.style.top = `-${currentScrollY}px`;

        // Show fullscreen overlay
        fullscreenOverlay.classList.add('active');
        document.body.classList.add('fullscreen-media-open');
      });
    });
  }

  // Add zoom to both desktop and mobile items
  addZoomToItems(mediaItemsDesktop, mediaItemsDesktop);
  addZoomToItems(mediaItemsMobile, mediaItemsDesktop);

  // Close fullscreen on close button click
  closeButton.addEventListener('click', function() {
    closeFullscreen();
  });

  // Close fullscreen on overlay click (only on background, not content)
  fullscreenOverlay.addEventListener('click', function(e) {
    if (e.target === fullscreenOverlay) {
      closeFullscreen();
    }
  });

  // Close fullscreen on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && fullscreenOverlay.classList.contains('active')) {
      closeFullscreen();
    }
  });

  // Add drag to scroll functionality
  let isDown = false;
  let startX;
  let startY;
  let scrollLeft;
  let scrollTop;

  fullscreenOverlay.addEventListener('mousedown', function(e) {
    if (e.target === closeButton || closeButton.contains(e.target)) return;
    isDown = true;
    fullscreenOverlay.style.cursor = 'grabbing';
    startX = e.pageX - fullscreenOverlay.offsetLeft;
    startY = e.pageY - fullscreenOverlay.offsetTop;
    scrollLeft = fullscreenOverlay.scrollLeft;
    scrollTop = fullscreenOverlay.scrollTop;
  });

  fullscreenOverlay.addEventListener('mouseleave', function() {
    isDown = false;
    fullscreenOverlay.style.cursor = 'grab';
  });

  fullscreenOverlay.addEventListener('mouseup', function() {
    isDown = false;
    fullscreenOverlay.style.cursor = 'grab';
  });

  fullscreenOverlay.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - fullscreenOverlay.offsetLeft;
    const y = e.pageY - fullscreenOverlay.offsetTop;
    const walkX = (x - startX) * 1.5;
    const walkY = (y - startY) * 1.5;
    fullscreenOverlay.scrollLeft = scrollLeft - walkX;
    fullscreenOverlay.scrollTop = scrollTop - walkY;
  });

  function closeFullscreen() {
    fullscreenOverlay.classList.remove('active');
    const previousScrollY = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.classList.remove('fullscreen-media-open');
    document.body.style.top = '';
    window.scrollTo(0, previousScrollY);
    try { delete document.body.dataset.scrollY; } catch (_) { document.body.dataset.scrollY = ''; }
  }
}

$( document ).ready(function() {
  addDialogEventListeners();
  setProductSwiper();
  setButtonsContainerHeight();
  handleMobileFooterVisibility();
  initProductMediaZoom();

  window.addEventListener('resize', function() {
    setButtonsContainerHeight();
  });
});